import AdversarialDialect from './AdversarialDialect'

export default AdversarialDialect
